import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { CornerRibbon } from "@/ui/Badges/CornerRibbon";
import type { ScheduleHoliday } from "./scheduleHolidays";
import { scheduleHolidayTooltip } from "./scheduleHolidayText";

type Props = {
	scheduleHoliday: ScheduleHoliday;
	/** See `CornerRibbon`: for a ribbon inside a control whose label already names the holiday. */
	// DEFAULT: false, the ribbon is the only place the holiday is named.
	decorative?: boolean;
	/** See `CornerRibbon`: the thin band for a phone's narrow day cell. */
	// DEFAULT: false, the full band with its word.
	compact?: boolean;
	dataTestId: string;
};

/** The "Holiday" band on a schedule day: solid once applied, dashed until then. */
export const ScheduleHolidayRibbon: FC<Props> = ({ scheduleHoliday, decorative = false, compact = false, dataTestId }) => {
	const { t } = useTranslation();
	return (
		<CornerRibbon
			label={t("holidays.schedule.ribbon.label")}
			tooltip={scheduleHolidayTooltip(t, scheduleHoliday)}
			variant={scheduleHoliday.applied ? "solid" : "dashed"}
			decorative={decorative}
			compact={compact}
			dataTestId={dataTestId}
		/>
	);
};
